/* eslint-disable prettier/prettier */
/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */

import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ListCards.css';
import ModalConfirmacionTurno from '../../../components/Telemedicina/ModalConfirmacionTurno/ModalConfirmacionTurno';
import SinHorariosDisponibles from '../../../components/Telemedicina/SinHorariosDisponibles/SinHorariosDisponibles';
import ModalConfirmacionTurnoResp from '../../../components/Telemedicina/ModalConfirmacionTurnoResp/ModalConfirmacionTurnoResp';
import ModalYaTomoTurno from '../../../components/Telemedicina/ModalYaTomoTurno/ModalYaTomoTurno';
import generateAbsoluteUrl from '../../../utils/generateAbsoluteUrl';
import CardHeader from '../../../components/Telemedicina/CardHeader/CardHeader';

class ListCards extends React.Component {
  // static getDataUser() {
  //   const auth = localStorage.getItem(LOCALSTORAGE_AUTH_KEY);
  //   let user;
  //   if (auth) {
  //     user = {
  //       email: JSON.parse(auth).modelEspecifico.email,
  //     };
  //   }
  //   return user;
  // }

  static capitalizeEach(name) {
    if (name) {
      const splittedName = name.toLowerCase().split(' ');
      return splittedName
        .map(str => str.charAt(0).toUpperCase() + str.substring(1))
        .join(' ');
    }
  }

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      dataTurno: '',
      nombreapellido: '',
      especialidad: '',
      prestadorId: '',
      show: false,
      yaTomo: null,
    };

    this.showModal = this.showModal.bind(this);
    this.renderCard = this.renderCard.bind(this);
    this.capitalizeEach = ListCards.capitalizeEach.bind(this);
  }

  componentWillReceiveProps(props) {
    if (this.props.confirmacionTurno !== props.confirmacionTurno) {
      const email = $('#email').val();
      $('#mail').html(email);
      $('#modalConfirmTurnoResp').modal('show');
    }
  }

  formatearHora = hora => `${hora.substr(0, 2)}:${hora.substr(2, 4)}`;

  convertDate = (date, hour) => {
    const days = [
      'Lunes',
      'Martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábado',
      'Domingo',
    ];
    const months = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];

    if (date) {
      const year = date.substr(0, 4);
      const month = date.substr(4, 2);
      const day = date.substr(6, 8);
      const hourFormated = `${hour.substr(0, 2)}:${hour.substr(2, 4)}`;
      const dateFormated = new Date(`${year}-${month}-${day} 00:00:00`);
      let dayWeek = dateFormated.getDay();
      if (dayWeek === 0) {
        dayWeek = 7;
      }
      const finalDate = `${days[dayWeek - 1]} ${day} de ${months[
        parseInt(month, 10) - 1
      ]} ${hourFormated} Hs`;
      // Martes 8 de agosto 8:15AM
      return finalDate;
    }
    return '';
  };

  closeModal = () => {
    this.setState({ show: false });
  };

  showModal(data, horario) {
    this.setState({ yaTomo: data.turnos[horario] });
    this.props.validarTurnoTomado(data.turnos[horario].fecha).then(resp => {
      if (resp && resp.showModal) {
        $('#ModalYaTomoTurno').modal({
          backdrop: 'static',
          keyboard: false,
        });
      } else {
        let prestadorId;
        let nombre;
        let apellido;

        if (data.turnos[horario].reemplazo.prestador === '') {
          prestadorId = data.turnos[horario].prestador;
          nombre = data.turnos[horario].titular.nombreAbre;
          apellido = data.turnos[horario].titular.apeRazon;
        } else {
          prestadorId = data.turnos[horario].reemplazo.prestador;
          nombre = data.turnos[horario].reemplazo.nombreAbre;
          apellido = data.turnos[horario].reemplazo.apeRazon;
        }
        // console.log(data.turnos[horario].fecha)
        this.setState({
          dataTurno: data.turnos[horario],
          nombre,
          apellido,
          prestadorId,
          especialidad: data.especialidad,
          show: true,
        });
      }
    });
  }

  renderCard(data) {
    // ///PRUEBA MOMENTANEA
    const horariosSalvoX5 = data.horarios.filter(
      h => !h.slice(2, 4).match(/\d5$/g),
    );
    // ///////////////////////
    let urlImage;

    if (window.location.host.includes('localhost')) {
      urlImage = 'https://swissmedical.com.ar/smgnewsite/images/telemedicina/';
    } else {
      urlImage = 'smgnewsite/images/telemedicina/';
    }
    const img = `${urlImage}${data.prestador}.jpg`;
    const imgDefault = `${urlImage}sin_foto.jpg`;
    if (horariosSalvoX5.length) {
      return (
        <div key={data.prestador}>
          <div className={`${s.card} card`}>
            <div className="media">
              {img ? (
                <img
                  id={data.prestador}
                  className={`${s.imgMedicos} align-self-center mr-3`}
                  src={img}
                  alt="Medico"
                  // onError={() => {
                  // $(`#${data.prestador}`).attr('src', imgDefault);
                  // }}
                />
              ) : (
                <img
                  id={imgDefault}
                  className={`${s.imgMedicos} align-self-center mr-3`}
                  src={imgDefault}
                  alt="Medico"
                />
              )}
              <div className="media-body">
                <h5 className="mt-0">
                  {this.capitalizeEach(data.nombre)} {data.apellido}
                </h5>
                <p>Horarios de Atención</p>
                {horariosSalvoX5 &&
                  horariosSalvoX5.map(option => (
                    <span key={option}>
                      <button
                        onClick={() => this.showModal(data, option)}
                        type="button"
                        data-toggle="modal"
                        className={`${s.button} btn btn-outline-danger`}
                      >
                        {this.formatearHora(option)}
                      </button>
                    </span>
                  ))}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  render() {
    if (this.props.turnosPorfecha.turnos) {
      if (this.props.turnosPorfecha.turnos.length === 0) {
        return (
          <div>
            <SinHorariosDisponibles />
          </div>
        );
      }
      // eslint-disable-next-line no-unused-vars
      let turns = '';

      const enviroment = generateAbsoluteUrl();

      if (this.props.specialityName === 'Well Test') {
        if (enviroment.includes('pre') || enviroment.includes('clubswiss')) {
          turns = this.props.turnosPorfecha.turnos.filter(
            prest => prest.prestador === '36274',
          );
        } else if (
          enviroment.includes('mobileint') ||
          enviroment.includes('srv-php01') ||
          enviroment.includes('localhost')
        ) {
          turns = this.props.turnosPorfecha.turnos.filter(
            prest => prest.prestador === '35238',
          );
        } else if (
          enviroment.includes('srv-php02') ||
          enviroment.includes('mobileqa')
        ) {
          turns = this.props.turnosPorfecha.turnos.filter(
            prest => prest.prestador === '35595',
          );
        }
      } else {
        turns = this.props.turnosPorfecha.turnos.filter(
          prest => prest.prestador !== '35210' && prest.prestador !== '35238' && prest.prestador !== '35645' && prest.prestador !== '35984'
        );
      }

      const hasHoursX0 = (hour) => hour.slice(2, 4).match(/\d0$/g);

      const turnsWithHoursX0 = turns.filter(
        t => t.horarios.some(hasHoursX0),
      );

      return (
        <div className={s.cardButton}>
          <ModalConfirmacionTurno
            // showModal={this.showModal}
            closeModal={this.closeModal}
            show={this.state.show}
            nombre={this.state.nombre}
            apellido={this.state.apellido}
            email={this.props.emailService}
            dataTurno={this.state.dataTurno}
            prestadorId={this.state.prestadorId}
            displayDate={`${this.convertDate(
              this.state.dataTurno.fecha,
              this.state.dataTurno.hora,
            )}`}
          />
          {turnsWithHoursX0.length ? <CardHeader
              fechaCard={this.props.fechaCard}
              turnosPorfecha={this.props.TurnosPorFecha}
            /> : ''}
          {turns.map(turn => this.renderCard(turn))}
          {this.state.yaTomo !== null && (
            <ModalYaTomoTurno turno={this.state.yaTomo} />
          )}
          <ModalConfirmacionTurnoResp/>
        </div>
      );
    }
    return <div />;
  }
}
const mapStateToProps = state => ({
  confirmacionTurno: state.telemedicina.confirmacion_turno,
  emailService: state.telemedicina.email,
});

export default connect(mapStateToProps, null)(withStyles(s)(ListCards));



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ListCards/ListCards.js